export default {
    init : false,
    originCart: {},
    products:[],
    checkoutStatus: null
}